import { useEffect } from "react";

import { useLazyQuery } from "@apollo/client";

import { GET_DEVICES_BY_NODE_ID } from "../../../common/operations/queries";
import { errorNotification } from "../../../common/variables/notification";
import client from "../../../configs/apolloClient";
import type {
  GetDevicesByNodeIdQuery,
  GetDevicesByNodeIdQueryVariables,
} from "../../../API";

export const DEVICES_TABLE_LIMIT = 100;

export const useGetDevicesByNode = (nodeId: string) => {
  useEffect(() => {
    fetchDevices(nodeId);
  }, [nodeId]);

  const handleRequestError = () => {
    client.cache
      .reset()
      .then(() => {
        errorNotification();
      })
      .catch(error => {
        console.error(error);
      });
  };

  const [getDevicesByNode, { data, loading }] = useLazyQuery<
    GetDevicesByNodeIdQuery,
    GetDevicesByNodeIdQueryVariables
  >(GET_DEVICES_BY_NODE_ID);

  const fetchDevices = (nodeId?: string | null, nextToken?: string) => {
    getDevicesByNode({
      variables: {
        nodeId: nodeId ?? "",
        nextToken,
      },
    })
      .then(response => {
        if (response?.data?.getDevicesByNodeId?.nextToken) {
          fetchDevices(nodeId, response?.data?.getDevicesByNodeId?.nextToken);
        }

        if (response.error) {
          handleRequestError();
        }
      })
      .catch(e => {
        console.error(e);

        handleRequestError();
      });
  };

  return { data, loading };
};
